import { vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8684fdaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-start" }
const _hoisted_2 = ["id", "name"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"gn-checkbox__input-block\" data-v-8684fdaa><svg class=\"gn-checkbox__icon\" version=\"1.1\" viewBox=\"0 0 17 12\" xmlns=\"http://www.w3.org/2000/svg\" data-v-8684fdaa><g fill=\"none\" fill-rule=\"evenodd\" data-v-8684fdaa><g transform=\"translate(-9 -11)\" fill=\"currentColor\" fill-rule=\"nonzero\" data-v-8684fdaa><path d=\"m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z\" data-v-8684fdaa></path></g></g></svg></div>", 1)
const _hoisted_4 = { class: "w-full block" }
const _hoisted_5 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenproxError = _resolveComponent("GenproxError")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gn-checkbox', _ctx.hasError ? 'error' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", _mergeProps({ type: "checkbox" }, {..._ctx.$props?.inputAttrs}, {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue) = $event)),
        id: _ctx.name,
        name: _ctx.name,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleInput(_ctx.inputValue))),
        class: "gn-checkbox__input"
      }), null, 16, _hoisted_2), [
        [_vModelCheckbox, _ctx.modelValue]
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", {
          for: _ctx.name,
          class: "select-none text-sm mt-0.5 text-gray-700 inline-block cursor-pointer"
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 8, _hoisted_5),
        _createVNode(_component_GenproxError, {
          validation: _ctx.validation,
          id: `${_ctx.name}-error`
        }, null, 8, ["validation", "id"])
      ])
    ])
  ], 2))
}